import { isExactMatch } from "../../../../utils/line-item-matchers/shared.js";
import { isSamePrescription } from "./prescription.js";
const areSamePrescriptionGlassesLineItem = (serverLineItem, draftLineItem) => {
  if (serverLineItem.__typename !== "LineItemBundle") {
    return false;
  }
  if (serverLineItem.typeDetails?.__typename !== "BundlePrescriptionGlassesTypeDetails") {
    return false;
  }
  const serverSkus = new Set(serverLineItem.bundleLineItems.map((bl) => bl.legacyProduct.sku));
  const draftSkus = /* @__PURE__ */ new Set([draftLineItem.sku, ...draftLineItem.bundleLineItems.map((b) => b.sku)]);
  return isExactMatch(serverSkus, draftSkus) && isSamePrescription(serverLineItem.typeDetails, draftLineItem.prescription);
};
export {
  areSamePrescriptionGlassesLineItem
};
//# sourceMappingURL=prescription-glasses-bundle.js.map
